/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Interestinwholedayschooling4Inputs */



/**

* @param {_Field_Interestinwholedayschooling4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_interestinwholedayschooling4 = /** @type {((inputs?: _Field_Interestinwholedayschooling4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Interestinwholedayschooling4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Interesse an Nachmittagsbetreuung")
});
export { _field_interestinwholedayschooling4 as "_field_interestInWholeDaySchooling" }